import './index.scss';
import { useSelector } from 'react-redux';
import { Backdrop, CircularProgress, LinearProgress } from '@material-ui/core';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import { Header } from '../Header';
import { Footer } from '@sharedComponents/Footer/Footer';
import { useAppLocale } from '@hooks/useAppLocale';
import { Container } from '@sharedComponents/Container';
import { AuthRoutes } from '@components/Routes';
import {
  appLoadingSelector,
  barLoadingSelector,
  selectAppLanguage,
} from '@selectors/app/appSettingsSelectors';
import { useNotifications } from '@hooks/useNotifications';
import { isLoggedInSelector } from '@selectors/app/registeredRouteSelector';
import { useAuth0 } from '@hooks/useAuth0';
import { environment } from '@env';
import { useTestLogin } from '@hooks/useTestLogin';

export function App() {
  const lang = useSelector(selectAppLanguage);
  const isLoggedIn = useSelector(isLoggedInSelector);
  const appLoading = useSelector(appLoadingSelector);
  const barLoading = useSelector(barLoadingSelector);
  const currentLocale = useAppLocale(lang);

  useNotifications();

  if (environment.auth0Enabled) {
    useAuth0();
  } else {
    useTestLogin();
  }

  return (
    <MuiPickersUtilsProvider utils={MomentUtils} locale={currentLocale}>
      <>
        <Backdrop className="backdrop-container" open={appLoading}>
          <CircularProgress color="inherit" />
        </Backdrop>
        {!isLoggedIn && environment.auth0Enabled && (
          <div className="auth-container">
            <AuthRoutes />
          </div>
        )}

        {!appLoading && (
          <div className="app-container">
            <div className="content-container">
              <Header />
              {barLoading ? (
                <LinearProgress color="secondary" />
              ) : (
                <div className="hidden-linear-progress"></div>
              )}
              <Container />
            </div>
            <Footer />
          </div>
        )}
      </>
    </MuiPickersUtilsProvider>
  );
}
